var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCaretinline = function SvgCaretinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 9 8"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#707070",
    d: "M4.553 5.57 2.155 2.829A.5.5 0 0 1 2.531 2h4.796a.5.5 0 0 1 .377.83L5.306 5.57a.5.5 0 0 1-.753 0Z",
    opacity: 0.75
  })));
};
export default SvgCaretinline;